import axios from 'axios';
import { createRefreshCoordinator } from './refresh-coordinator.cjs';
import { resolveApiBase } from '@/utils/core.cjs';

const ACCESS = 'cms_access_token';
const REFRESH = 'cms_refresh_token';
export const tokens = {
  access: () => localStorage.getItem(ACCESS), refresh: () => localStorage.getItem(REFRESH),
  set(pair) { localStorage.setItem(ACCESS, pair.access_token); localStorage.setItem(REFRESH, pair.refresh_token); },
  clear() { localStorage.removeItem(ACCESS); localStorage.removeItem(REFRESH); },
};
// Public configuration: VUE_APP_API_BASE_URL. VUE_APP_API_URL remains a legacy fallback for existing deployments.
export const API_BASE_URL = resolveApiBase(process.env);
// `paramsSerializer.indexes: null` is what makes a repeated query parameter
// repeat. Axios 1.x writes an array as `attr[]=a&attr[]=b` by default, and
// FastAPI reads `list[str]` off the *bare* key — `attr[]` is simply a different
// parameter it never looks at, so the filter silently did nothing rather than
// erroring. That already shipped: Danh mục vật tư's thuộc tính filters
// (`?attr=12:5`) and every array param since have been sent in a shape the API
// ignores. One option here fixes all of them; a per-call serializer would have
// left the next one to rediscover it.
export const api = axios.create({ baseURL: API_BASE_URL, timeout: 20000, paramsSerializer: { indexes: null } });
const refreshClient = axios.create({ baseURL: API_BASE_URL });
const refreshOnce = createRefreshCoordinator(async () => {
  const refreshToken = tokens.refresh();
  if (!refreshToken) throw new Error('Missing refresh token');
  const { data } = await refreshClient.post('/auth/refresh', { refresh_token: refreshToken });
  tokens.set(data); return data.access_token;
});
api.interceptors.request.use((config) => { const token = tokens.access(); if (token) config.headers.Authorization = `Bearer ${token}`; return config; });
api.interceptors.response.use((response) => response, async (error) => {
  const request = error.config || {};
  if (error.response?.status === 401 && !request._retried && !request.url?.includes('/auth/')) {
    request._retried = true;
    try { request.headers.Authorization = `Bearer ${await refreshOnce()}`; return api(request); }
    catch (_) { tokens.clear(); window.dispatchEvent(new Event('auth:expired')); if (location.pathname !== '/login') location.assign(`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`); }
  }
  const payload = error.response?.data?.error;
  error.normalized = { status: error.response?.status || 0, code: payload?.code || 'NETWORK_ERROR', message: payload?.message || 'Không thể kết nối máy chủ', fields: payload?.field_errors || payload?.fields || {}, requestId: payload?.request_id };
  return Promise.reject(error);
});
export default api;
